// pages/MaintenancePage.js
import React from 'react'
import './MaintenancePage.css'

function MaintenancePage () {
  return (
    <div className='maintenance-container'>
      <div className='maintenance-content'>
        <div className='maintenance-icon'>
          <svg
            viewBox='0 0 24 24'
            fill='none'
            stroke='currentColor'
            strokeWidth='2'
            strokeLinecap='round'
            strokeLinejoin='round'
          >
            <path d='M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z' />
          </svg>
        </div>

        <h1>🔧 Wartungsarbeiten</h1>

        <p className='maintenance-message'>
          Wir führen gerade wichtige Sicherheitsupdates durch, um Ihre Daten
          noch besser zu schützen.
        </p>

        <div className='maintenance-details'>
          <div className='detail-item'>
            <svg
              viewBox='0 0 24 24'
              fill='none'
              stroke='currentColor'
              strokeWidth='2'
            >
              <circle cx='12' cy='12' r='10' />
              <polyline points='12 6 12 12 16 14' />
            </svg>
            <span>Geschätzte Dauer: 120-240 Minuten</span>
          </div>

          <div className='detail-item'>
            <svg
              viewBox='0 0 24 24'
              fill='none'
              stroke='currentColor'
              strokeWidth='2'
            >
              <path d='M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z' />
            </svg>
            <span>Sicherheitsupdates & Firestore Rules</span>
          </div>

          <div className='detail-item'>
            <svg
              viewBox='0 0 24 24'
              fill='none'
              stroke='currentColor'
              strokeWidth='2'
            >
              <path d='M22 11.08V12a10 10 0 1 1-5.93-9.14' />
              <polyline points='22 4 12 14.01 9 11.01' />
            </svg>
            <span>Cloud Functions Deployment</span>
          </div>
        </div>

        <div className='maintenance-progress'>
          <div className='progress-bar'>
            <div className='progress-fill'></div>
          </div>
          <p className='progress-text'>Installation läuft...</p>
        </div>

        <div className='maintenance-contact'>
          <p>
            Bei Fragen erreichen Sie uns unter{' '}
            <a href='mailto:xaver.ebetshuber@gmail.com'>
              xaver.ebetshuber@gmail.com
            </a>
          </p>
        </div>

        <div className='maintenance-footer'>
          <p className='update-time'>
            Letzte Aktualisierung: {new Date().toLocaleString('de-DE')}
          </p>
          <button
            className='reload-button'
            onClick={() => window.location.reload()}
          >
            <svg
              viewBox='0 0 24 24'
              fill='none'
              stroke='currentColor'
              strokeWidth='2'
            >
              <polyline points='23 4 23 10 17 10' />
              <path d='M20.49 15a9 9 0 1 1-2.12-9.36L23 10' />
            </svg>
            Seite neu laden
          </button>
        </div>
      </div>
    </div>
  )
}

export default MaintenancePage
